module.exports = "<h1 mat-dialog-title>Are you sure?</h1>\n<div mat-dialog-content>\n    <app-loader [isLoading]=\"loading\" style=\"display:inline-block\"></app-loader>\n\n</div>\n<div mat-dialog-actions>\n  <button mat-button mat-dialog-close [disabled]=\"loading\">Cancel</button>\n  <button mat-button [disabled]=\"loading\" (click)=\"decommissionKiosk()\">Yes</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-decommission-dialog/kiosk-decommission-dialog.component.html
// module id = ./src/app/kiosk-decommission-dialog/kiosk-decommission-dialog.component.html
// module chunks = main